module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-19-min.c21fc5b3.jpg";